import { RestClient } from "@infrastructure/clients/http/clients/base/rest.client";

export interface LongPollingOptions {
  onMessage: (data: any) => void;
  onError?: (error: Error) => void;
  onClose?: () => void;
  reconnect?: boolean;
  reconnectDelay?: number;
  timeout?: number;
}

export abstract class LongPollingClient extends RestClient {
  abstract baseUrl: string;
  private pollingAbortController: AbortController | null = null;
  private isPolling = false;
  private currentEndpoint: string | null = null;

  async startPolling(endpoint: string, options: LongPollingOptions): Promise<() => void> {
    this.isPolling = true;
    this.currentEndpoint = endpoint;
    this.pollingAbortController = new AbortController();

    const poll = async () => {
      if (!this.isPolling) return;

      try {
        const timeout = options.timeout || 30000;
        const timeoutController = new AbortController();
        const timeoutId = setTimeout(() => timeoutController.abort(), timeout);
        
        // Используем основной signal, если есть
        const signal = this.pollingAbortController?.signal || timeoutController.signal;

        const result = await this.request(
          "GET",
          endpoint,
          {
            signal,
          }
        );

        clearTimeout(timeoutId);

        options.onMessage(result.data);

        // Продолжаем polling
        if (this.isPolling) {
          poll();
        }
      } catch (error: any) {
        if (error.name === "AbortError") {
          return;
        }

        options.onError?.(error as Error);

        if (this.isPolling && options.reconnect !== false) {
          const delay = options.reconnectDelay || 1000;
          setTimeout(() => {
            if (this.isPolling) poll();
          }, delay);
        }
      }
    };

    poll();

    return () => {
      this.stopPolling();
    };
  }

  stopPolling(): void {
    this.isPolling = false;
    this.pollingAbortController?.abort();
    this.pollingAbortController = null;
    this.currentEndpoint = null;
  }

  isPollingActive(): boolean {
    return this.isPolling;
  }
}

